import { Reducer } from 'redux';
import MapActionTypes from './types';
import { MapState } from './types';

export const initialState: MapState = {
  geocode: null,
  suggestion: [],
  suggestionError: '',
  basemapOptions: [],
  basemapError: '',
  featureLayerExtent: null,
  featureLayerfeatures: null,
  addressCandidate: null,
  addressCandidateError: '',
  mapSearchWithExtentZoom: [true]
};

const reducer: Reducer<MapState> = (state = initialState, action: any) => {
  switch (action.type) {
    case MapActionTypes.GET_GEOCODE_SUCCESS:
      return {
        ...state,
        geocode: action.payload
      };
    case MapActionTypes.GET_GEOCODE_FAILURE:
      return {
        ...state,
        geocode: action.payload
      };
    case MapActionTypes.CLEAR_GEOCODE:
      return {
        ...state,
        geocode: null
      };
    case MapActionTypes.GET_PLACE_SUGGESTION_SUCCESS:
      return {
        ...state,
        suggestion: action.payload
      };
    case MapActionTypes.GET_PLACE_SUGGESTION_FAILURE:
      return {
        ...state,
        suggestion: [],
        suggestionError: action.payload
      };
    case MapActionTypes.CLEAR_PLACE_SUGGESTION:
      return {
        ...state,
        suggestion: [],
        suggestionError: ''
      };
    case MapActionTypes.GET_HEXBIN_CLASS_BREAKS_SUCCESS:
      return {
        ...state,
        hexbinClassBreaks: action.payload
      };
    case MapActionTypes.GET_HEXBIN_CLASS_BREAKS_FAILURE:
    case MapActionTypes.GET_HEXBIN_CLASS_BREAKS_START:
      return {
        ...state,
        hexbinClassBreaks: undefined
      };
    case MapActionTypes.GET_BASE_MAPS_SUCCESS:
      return {
        ...state,
        basemapOptions: action.payload,
        basemapError: ''
      };
    case MapActionTypes.GET_BASE_MAPS_FAILURE:
      return {
        ...state,
        basemapOptions: [],
        basemapError: action.payload
      };
    case MapActionTypes.CLEAR_BASE_MAPS:
      return {
        ...state,
        basemapOptions: [],
        basemapError: ''
      };
    case MapActionTypes.QUERY_FEATURE_LAYER_EXTENT_SUCCESS:
      return {
        ...state,
        featureLayerExtent: action.payload
      };
    case MapActionTypes.QUERY_FEATURE_LAYER_EXTENT_FAILURE:
      return {
        ...state,
        featureLayerExtent: action.payload
      };
    case MapActionTypes.CLEAR_FEATURE_LAYER_EXTENT:
      return {
        ...state,
        featureLayerExtent: null
      };
    case MapActionTypes.QUERY_FEATURE_LAYER_FEATURES_SUCCESS:
      return {
        ...state,
        featureLayerfeatures: action.payload
      };
    case MapActionTypes.QUERY_FEATURE_LAYER_FEATURES_FAILURE:
      return {
        ...state,
        featureLayerfeatures: action.payload
      };
    case MapActionTypes.CLEAR_FEATURE_LAYER_FEATURES:
      return {
        ...state,
        featureLayerfeatures: null
      };
    case MapActionTypes.GET_PLACE_ADDRESS_CANDIDATE_START:
      return {
        ...state,
        addressCandidate: null
      };
    case MapActionTypes.GET_PLACE_ADDRESS_CANDIDATE_SUCCESS:
      return {
        ...state,
        addressCandidate: action.payload
      };
    case MapActionTypes.GET_PLACE_ADDRESS_CANDIDATE_FAILURE:
      return {
        ...state,
        addressCandidate: null,
        addressCandidateError: action.payload
      };
    case MapActionTypes.CLEAR_PLACE_ADDRESS_CANDIDATE:
      return {
        ...state,
        addressCandidate: null
      };
    case MapActionTypes.GET_GEOSCAPE_ADDRESS_START:
      return {
        ...state,
        geoscapeAddress: undefined
      };
    case MapActionTypes.GET_GEOSCAPE_ADDRESS_SUCCESS:
      return {
        ...state,
        geoscapeAddress: action.payload
      };
    case MapActionTypes.GET_GEOSCAPE_ADDRESS_FAILURE:
      return {
        ...state,
        geoscapeAddress: undefined,
        geoscapeAddressError: action.payload
      };
    case MapActionTypes.GET_GEOSCAPE_LAND_PARCEL_START:
      return {
        ...state,
        landParcel: undefined
      };
    case MapActionTypes.GET_GEOSCAPE_LAND_PARCEL_SUCCESS:
      return {
        ...state,
        landParcel: action.payload
      };
    case MapActionTypes.GET_GEOSCAPE_LAND_PARCEL_FAILURE:
      return {
        ...state,
        landParcel: undefined,
        geoscapeAddressError: action.payload
      };
    case MapActionTypes.CLEAR_GEOSCAPE_ADDRESS:
      return {
        ...state,
        geoscapeAddress: undefined,
        landParcel: undefined
      };
    case MapActionTypes.CLEAR_GEOSCAPE_LAND_PARCEL:
      return {
        ...state,
        landParcel: undefined
      };
    case MapActionTypes.SET_IS_OPEN_BASE_MAP_PANEL:
      return {
        ...state,
        IsOpenBaseMapPanel: action.payload
      };
    case MapActionTypes.SET_MAP_SEARCH_WITH_EXTENT_ZOOM:
      return {
        ...state,
        mapSearchWithExtentZoom: action.payload
      };
    default:
      return state;
  }
};

export { reducer as MapReducer };
